import * as React from 'react'

const BottomSpace = () => {
    return (
        <div style={{ height: "64px" }}/>
    )
}

export default BottomSpace